import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import GlobalContext from "../../../framework/GlobalContext";
import NumberInput from "../../../framework/NumberInput";
import { displayToast } from "../../../framework/toast/toastUtils";

const AddFrequency = (props) => {
  const {
    index,
    frequencyRowData,
    showDeleteIcon = true,
    onDeleteFrequency = () => {},
    frequencies = [],
    onChange = () => {},
  } = props;

  const { setCurrentComponent } = useContext(GlobalContext);
  const withPhoneCap = ({ value }) => value > 0;

  const getMarker = useCallback(
    (direction, rowItemIndex, rowIndex) => {
      switch (direction) {
        case "right":
          if (rowItemIndex === 0) {
            return `row_item_1_${index}`;
          }
          if (rowItemIndex === 1) {
            return `row_item_2_${index}`;
          }
          if (rowItemIndex === 2) {
            return `row_item_3_${index}`;
          }
          if (rowItemIndex === 3) {
            if (document.getElementById(`row_item_0_${index + 1}`)) {
              return `row_item_0_${index + 1}`;
            }
            return `row_item_3_${index}`;
          }
          break;
        case "left":
          if (rowItemIndex === 0) {
            if (document.getElementById(`row_item_0_${index - 1}`)) {
              return `row_item_3_${index - 1}`;
            }
            return `row_item_0_${index}`;
          }
          if (rowItemIndex === 1) {
            return `row_item_0_${index}`;
          }
          if (rowItemIndex === 2) {
            return `row_item_1_${index}`;
          }
          if (rowItemIndex === 3) {
            return `row_item_2_${index}`;
          }
          break;
        case "up":
          return `row_item_${rowItemIndex}_${rowIndex}`;
        case "down":
          return `row_item_${rowItemIndex}_${rowIndex}`;
        default:
          return `row_item_${rowItemIndex}_${rowIndex}`;
      }
    },
    [index]
  );

  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "delete") {
        onDeleteFrequency(index);
        return;
      }
    },
    [index, onDeleteFrequency]
  );

  useEffect(() => {
    window.addEventListener("keyup", keyupListener);
    return () => {
      window.removeEventListener("keyup", keyupListener);
    };
  }, [keyupListener]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        justifyContent: "space-between",
      }}
    >
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_0_${index}`}
          autoFocus
          label="From Frequency"
          value={frequencyRowData?.fromFrequency}
          inputStyle={{
            background: "lightblue",
            flex: 1,
          }}
          onChange={(e, value) => {
            onChange("fromFrequency", +e.target.value);
          }}
          isAllowed={withPhoneCap}
          onBlur={() => {
            if (frequencies?.length > 1) {
              if (
                frequencyRowData?.fromFrequency <=
                frequencies[frequencies?.length - 2]?.toFrequency
              ) {
                displayToast({
                  type: "error",
                  title:
                    "From frequency should be greater than previous to frequency",
                });
              }
            }
          }}
          onFocus={() => {
            setCurrentComponent("add_frequency_slab_from_frequency");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 0, index) === "row_item_0_0"
                  ? "add_frequency_slab_name"
                  : getMarker("up", 0, index - 1),
              down: getMarker("down", 0, index + 1),
              left:
                getMarker("left", 0, index) === "row_item_0_0"
                  ? "add_frequency_slab_remarks"
                  : getMarker("left", 0, index),
              right: getMarker("right", 0, index),
            }),
          }}
        />
      </div>
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_1_${index}`}
          label="To Frequency"
          value={frequencyRowData?.toFrequency}
          inputStyle={{
            background: "lightblue",
            flex: 1,
          }}
          onChange={(e) => onChange("toFrequency", +e.target.value)}
          onFocus={() => {
            setCurrentComponent("add_frequency_slab_to_frequency");
          }}
          isAllowed={withPhoneCap}
          onBlur={() => {
            if (
              frequencyRowData?.toFrequency < frequencyRowData?.fromFrequency
            ) {
              displayToast({
                type: "error",
                title: "To frequency should be greater than from frequency",
              });
            }
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 1, index) === "row_item_1_0"
                  ? "add_frequency_slab_branch"
                  : getMarker("up", 1, index - 1),
              down: getMarker("down", 1, index + 1),
              left: getMarker("left", 1, index),
              right: getMarker("right", 1, index),
            }),
          }}
        />
      </div>
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_2_${index}`}
          label="Minimum Days"
          value={frequencyRowData?.minDays}
          onChange={(e) => {
            const value = +e.target.value;
            onChange("minDays", value);
          }}
          onFocus={() => {
            setCurrentComponent("add_frequency_slab_min_days");
          }}
          isAllowed={withPhoneCap}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 2, index) === "row_item_2_0"
                  ? "add_frequency_slab_branch"
                  : getMarker("up", 2, index - 1),
              down: getMarker("down", 2, index + 1),
              left: getMarker("left", 2, index),
              right: getMarker("right", 2, index),
            }),
          }}
        />
      </div>
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_3_${index}`}
          label="Maximum Days"
          value={frequencyRowData?.maxDays}
          onChange={(e) => {
            const value = +e.target.value;
            onChange("maxDays", value);
          }}
          isAllowed={withPhoneCap}
          onFocus={() => {
            setCurrentComponent("add_frequency_slab_max_days");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up:
                getMarker("up", 3, index) === "row_item_2_0"
                  ? "add_frequency_slab_remarks"
                  : getMarker("up", 3, index - 1),
              down: getMarker("down", 3, index + 1),
              left: getMarker("left", 3, index),
              right: getMarker("right", 3, index),
            }),
          }}
        />
      </div>
      {showDeleteIcon && (
        <IconButton onClick={() => onDeleteFrequency(index)}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default AddFrequency;
